/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable no-alert */
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import FakeModalLoading from 'src/components/functional/FakeModalLoading';
import { apiAuth } from '../../api';

export default function ApproveInvite(): JSX.Element {
  const [isLoading, setIsLoading] = useState(false);

  const requestDoneRef = useRef(false);

  const { token } = useParams();

  useEffect(() => {
    if (!requestDoneRef.current) {
      requestDoneRef.current = true;

      setIsLoading(true);

      apiAuth
        .registerUserForConsultant(token)
        .then(() => {
          alert('Convite aceito com sucesso!');
          setIsLoading(false);
        })
        .catch((e) => {
          if (e.response.data.message.includes('Duplicate entry')) {
            alert(
              'Este convite já foi aceito! Por favor, verifique se a vinculação entre cliente e consultor aconteceu corretamente.'
            );
          } else {
            alert(
              `Ocorreu um erro ao aceitar o convite! Por favor, tente novamente mais tarde ou contate a central! Erro: ${e.response.data.message}`
            );
          }

          setIsLoading(false);
        });
    }
  }, []);

  return <div>{isLoading && <FakeModalLoading />}</div>;
}
